import SignUp from "@/modules/vendor/pages/Register/SignUp";
import VerifyEmailOtp from "@/modules/vendor/pages/VerifyEmailOtp";
import VendorLoginPage from "@/modules/vendor/pages/Login";
import VendorForgetPassword from "@/modules/vendor/pages/ForgetPassword/EnterEmail";
import ResetPasswordOtp from "@/modules/vendor/pages/ForgetPassword/ResetPasswordOtp";
import SetNewPassword from "@/modules/vendor/pages/ForgetPassword/SetNewPassword";
import AuthLayout from "@/layouts/AuthLayout";

const vendorAuthRoutes = [
  {
    path: "/vendor/auth",
    element: <AuthLayout />, // The VendorAuthLayout is the parent for auth routes
    children: [
      { path: "login", element: <VendorLoginPage /> },
      { path: "register", element: <SignUp /> },
      { path: "forgot-password", element: <VendorForgetPassword /> },
      { path: "verify-password-reset-otp", element: <ResetPasswordOtp /> },
      { path: "reset-password", element: <SetNewPassword /> },
      { path: "verify-email-otp", element: <VerifyEmailOtp /> },
    ],
  },
];

export default vendorAuthRoutes;
